import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const registrationApi = apiResourceBuilder(
  'emts/eventRegistrationDetails'
);

export const registrationSchema = new schema.Entity(
  'registration',
  {},
  { idAttribute: 'eventKey' }
);

export default entityActionCreator({
  schema: registrationSchema,
  api: registrationApi,
});



// WEBPACK FOOTER //
// ./src/App/events/actions/registration/index.js